import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {userRegister} from "../../services/userRegister";
import TextareaAutosize from 'react-autosize-textarea';
import {langRegister} from "../../services/langRegister";
import innerHtml from 'react-inner-html';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {scraperRegister} from "../../services/scraperRegister";
import BoosterHeader from "../../components/booster-header/component";
import {flowRegister} from "../../services/flowRegister";
import {themeRegister} from "../../services/themeRegister";
import {yieldlockRegister} from "../../services/yieldlockRegister";
import {tokenRegister} from "../../services/tokenRegister";

class BoosterSlogansDivided extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            quotes: [],
            selected: {},
            isLoadingButton: false,
            isLoading: true,
            page: 1,
            page_load: 5,
            admin: false,
            customQuote: {
                selected: false,
                saved: false,
                text: "",
                modal: false,
                custom: true
            },
            customCount: 0,
            error: false,
            sale: "instant",
            step: "activation",
            steps: {
                activation: {title: {sv: "..välj en slogan som väcker intresse..", en: "..pick a slogan that creates interest.."}, value: "activation", next: "validation", previous: null, step: 1, selected: null},
                validation: {title: (salesChannelRegister.get("name")==="yieldlock"?{sv: "..välj en slogan som validerar..", en: "..pick a slogan that validates.."}:{sv: "..välj en slogan som framhäver en detalj..", en: "..pick a slogan that promotes a feature.."}), value: "validation", next: "offer", previous: "activation", step: 2, selected: null},
                offer: {title: {sv: "..välj en slogan som skapar mervärde..", en: "..pick a slogan that adds value.."}, value: "offer", next: "action", previous: "validation", step: 3, selected: null},
                action: {title: {sv: "..välj en slogan som uppmanar till handling..", en: "..pick a slogan that calls for action.."}, value: "action", next: null, previous: "offer", step: 4, selected: null}
            }
        };
        this._renderAdminQuote = this._renderAdminQuote.bind(this);
    };

    componentDidMount() {
        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateUser();

        if(window.innerWidth > 1050){
            this.setState({page_load: 10}, () => {
                this._updateData();
            });
        }else{
            this.setState({page_load: 8}, () => {
                this._updateData();
            });
        }

        this._updateScraperData();

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/booster/slogans');
            ReactGA4.send({ hitType: "pageview", page: "/booster/slogans" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        //CHECK VIEW
        let view = quotesRegister.getView();
        if(view === "custom"){
            cartRegister.setQuotes(null);
        }
        quotesRegister.setView(null);

        cartRegister.setSelectedIndustries(null);

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({admin: user.reseller || user.inhouse, inhouse: user.inhouse, reseller: user.reseller});
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();
            /*
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/images");
                }
            }
            */
            if (stored_data.industry) {
                this.setState({
                    industry: stored_data.industry
                }, () => {
                    this._updateQuotes(this.state.industry.id, salesChannelRegister.get('market'), langRegister.lang());
                });
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+  "/booster/images");
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateScraperData() {
        /*
        let scraper_data = JSON.parse(scraperRegister.get());
        try {
            if (scraper_data.additional_information.facts.listing_type.indentifier === "sale") {
                this.setState({sale: "sell", scraped: scraper_data.scraped}, () => {
                    this._updateData();
                });
            } else {
                this.setState({sale: "rent", scraped: scraper_data.scraped}, () => {
                    this._updateData();
                });
            }
        } catch (e) {}
        */

        this.setState({sale: flowRegister.getValue("slogan_type")}, () => {
            this._updateData();
        });
    }

    _updateQuotes(industry, market, lang) {
        try {
            let stored_quotes = null;//quotesRegister.get();
            let stored_page = null;//quotesRegister.page();
            if (stored_quotes) {
                this.setState({
                    quotes: stored_quotes,
                    page: stored_page,
                    isLoading: false
                }, () => {
                    this._updateQuote();
                });
            } else {
                dataRegister.quotes(industry, market, lang).then((data) => {

                    if (data.errors) {
                        this.setState({
                            isLoading: false
                        });
                    } else {

                        let all = data;
                        let slogans = [];

                        //ADD EXTRAS
                        if (flowRegister.getValue("slogan_extras")) {
                            let extras = flowRegister.getValue("slogan_extras");
                            let highlight = flowRegister.getValue("slogan_highlight");
                            for (let i = 0; i < extras.length; i++) {

                                if (extras[i].title.indexOf(highlight) === -1 && (extras[i].highlight === undefined || extras[i].highlight === null)) {
                                    extras[i].highlight = true;
                                }

                                slogans.unshift({
                                    slogan: extras[i].title,
                                    detail: extras[i].detail,
                                    id: extras[i].title + extras[i].detail,
                                    custom: true,
                                    highlight: extras[i].highlight,
                                    sale: "both",
                                    type: (salesChannelRegister.get("name")==="yieldlock"?"yieldlock":(salesChannelRegister.get("name")==="boostabostad"?"boostabostad":"property")),
                                    index: 0
                                });
                                //console.log(extras[i].title);
                                this.state.customCount++;
                            }
                        }

                        //EXCLUDE
                        if (flowRegister.getValue("slogan_excludes")) {
                            let excluded = flowRegister.getValue("slogan_excludes");
                            let all_slogans = [];
                            for (let i = 0; i < all.length; i++) {
                                let exist = false;
                                for (let m = 0; m < excluded.length; m++) {
                                    if (excluded[m].toLowerCase() === all[i].slogan.toLowerCase()) {
                                        exist = true;
                                        break;
                                    }
                                }
                                if (!exist) {
                                    all_slogans.push(all[i]);
                                }
                            }
                            all_slogans = all_slogans.sort(function (a, b) {
                                if (a.slogan < b.slogan) {
                                    return -1;
                                }
                                if (a.slogan > b.slogan) {
                                    return 1;
                                }
                                return 0;
                            });
                            slogans = slogans.concat(all_slogans);
                        } else {
                            all = all.sort(function (a, b) {
                                if (a.slogan < b.slogan) {
                                    return -1;
                                }
                                if (a.slogan > b.slogan) {
                                    return 1;
                                }
                                return 0;
                            });
                            slogans = slogans.concat(all);
                        }

                        //MATCH AMENATIES
                        if (flowRegister.getValue("slogan_matches")) {
                            let top = [];
                            let bottom = [];
                            let matches = flowRegister.getValue("slogan_matches");
                            for (let i = 0; i < slogans.length; i++) {
                                let exist = false;
                                for (let m = 0; m < matches.length; m++) {
                                    if (matches[m].toLowerCase() === slogans[i].slogan.toLowerCase()) {
                                        slogans[i].highlight = true;
                                        top.push(slogans[i]);
                                        exist = true;
                                        break;
                                    }
                                }
                                if (!exist) {
                                    bottom.push(slogans[i]);
                                }
                            }
                            slogans = top.concat(bottom);
                        }

                        //MATCH TAGS
                        /*
                        if(flowRegister.getValue("slogan_tags")){
                            let top = [];
                            let bottom = [];
                            let tags = flowRegister.getValue("slogan_tags");
                            for(let i = 0; i < slogans.length; i++){
                                let exist = false;
                                for(let m = 0; m < tags.length; m++){
                                    if(tags[m].toLowerCase() === slogans[i].slogan.toLowerCase()){
                                        slogans[i].highlight = true;
                                        top.push(slogans[i]);
                                        exist = true;
                                        break;
                                    }
                                }
                                if(!exist){
                                    bottom.push(slogans[i]);
                                }
                            }
                            slogans = top.concat(bottom);
                        }
                        /*/

                        this.setState({
                            quotes: slogans,
                            customCount: this.state.customCount, //this.state.customCount + custom.length,
                            isLoading: false
                        }, () => {
                            quotesRegister.set(this.state.quotes, 1, lang);
                            this._updateQuote();
                        });
                    }

                }, (error) => {
                    this.setState({error: true});
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuote() {
        try {
            let stored_quotes = cartRegister.get();
            if (stored_quotes.quotes) {
                for(let key in stored_quotes.quotes){
                    if(stored_quotes.quotes[key].index === 0){
                        this.state.steps.activation.selected = stored_quotes.quotes[key];
                    }
                    if(stored_quotes.quotes[key].index === 1){
                        this.state.steps.validation.selected = stored_quotes.quotes[key];
                    }
                    if(stored_quotes.quotes[key].index === 2){
                        this.state.steps.offer.selected = stored_quotes.quotes[key];
                    }
                    if(stored_quotes.quotes[key].index === 3){
                        this.state.steps.action.selected = stored_quotes.quotes[key];
                    }
                }
                this.setState({steps: this.state.steps});
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectQuote(prop) {
        try {
            if (!this.state.isLoading && !this.state.isSelecting) {
                let exist = false;
                try {
                    if(this.state.steps[this.state.step].selected.id === prop.id){
                        this.state.steps[this.state.step].selected = null;
                        exist = true;
                    }
                }catch (e) {}
                if(!exist){
                    this.setState({isSelecting: true}, () => {
                        this.state.steps[this.state.step].selected = prop;
                        if(this.state.steps[this.state.step].next){
                            //last step "action" not executed
                            this.setState({
                                steps: this.state.steps,
                            }, () => {
                                if(prop.detail === "activation"){
                                    let theme_data = themeRegister.getValue();
                                    theme_data.slogan_activation = prop.slogan;
                                    themeRegister.setValue(theme_data);
                                }
                                if(prop.detail === "validation"){
                                    let theme_data = themeRegister.getValue();
                                    theme_data.slogan_validation = prop.slogan;
                                    themeRegister.setValue(theme_data);
                                }
                                if(prop.detail === "offer"){
                                    let theme_data = themeRegister.getValue();
                                    if(salesChannelRegister.get('name') === "yieldlock"){
                                        let up_front = yieldlockRegister.getValue("up_front");
                                        let yield_value = yieldlockRegister.getValue("yield");
                                        let years_value = yieldlockRegister.getValue("years");
                                        if (up_front && years_value && yield_value) {

                                            years_value = JSON.parse(years_value);
                                            let string = (yield_value * years_value.years)  + "% ROI Up-Front";
                                            theme_data.slogan_offer = string;

                                        }else if(years_value && yield_value){
                                            years_value = JSON.parse(years_value);
                                            let string = yield_value + "% Yield Assured (" + years_value.years + "Y)";
                                            theme_data.slogan_offer = string;
                                        }else{
                                            theme_data.slogan_offer = prop.slogan;
                                        }
                                    }else{
                                        theme_data.slogan_offer = prop.slogan;
                                    }
                                    themeRegister.setValue(theme_data);
                                }
                                if(prop.detail === "action"){
                                    let theme_data = themeRegister.getValue();
                                    theme_data.slogan_action = prop.slogan;
                                    themeRegister.setValue(theme_data);
                                }
                                setTimeout(() => {
                                    window.scrollTo(0, 0);
                                    this.setState({
                                        step: this.state.steps[this.state.step].next,
                                        isSelecting: false
                                    })
                                }, 200);
                            })
                        }else{

                            this.setState({
                                steps: this.state.steps,
                            }, () => {
                                setTimeout(() => {
                                    try {
                                        let selected = {};
                                        selected[this.state.steps.activation.selected.id] = JSON.parse(JSON.stringify(this.state.steps.activation.selected));
                                        selected[this.state.steps.activation.selected.id].index = 0;
                                        selected[this.state.steps.activation.selected.id].selected = true;

                                        selected[this.state.steps.validation.selected.id] = JSON.parse(JSON.stringify(this.state.steps.validation.selected));
                                        selected[this.state.steps.validation.selected.id].index = 1;
                                        selected[this.state.steps.validation.selected.id].selected = true;

                                        selected[this.state.steps.offer.selected.id] = JSON.parse(JSON.stringify(this.state.steps.offer.selected));
                                        selected[this.state.steps.offer.selected.id].index = 2;
                                        selected[this.state.steps.offer.selected.id].selected = true;

                                        selected[this.state.steps.action.selected.id] = JSON.parse(JSON.stringify(this.state.steps.action.selected));
                                        selected[this.state.steps.action.selected.id].index = 3;
                                        selected[this.state.steps.action.selected.id].selected = true;

                                        cartRegister.setQuotes(selected);
                                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());

                                        //SET
                                        if(this.state.steps.action && this.state.steps.action.selected){

                                            try {
                                                let theme_data = themeRegister.getValue();
                                                theme_data.slogan_action = this.state.steps.action.selected.slogan;
                                                themeRegister.setValue(theme_data);
                                            }catch (e) {}

                                            themeRegister.setItem("last_subtitle", this.state.steps.action.selected.slogan);
                                        }

                                        if(salesChannelRegister.get("name") === "yieldlock"){
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
                                        }else{
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
                                        }
                                    }catch (e) {}
                                }, 200);
                            });
                        }
                    });
                }else{
                    this.setState({
                        steps: this.state.steps
                    })
                }
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectCustomQuote() {
        try {
            if (!this.state.isLoading) {
                this.state.customQuote.selected = true;
                this.setState({
                    customQuote: this.state.customQuote,
                    selected: {}
                });
                cartRegister.setAdAdminQuotes(this.state.customQuote);
                if(salesChannelRegister.get("name") === "yieldlock"){
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
                }else{
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
                }
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _setCustomQuote(){

        try {
            let words = this.state.customQuote.text.split(" ");
            for(let i = 0; i < words.length; i++){
                words[i] = capitalizeFLetter(words[i]);
            }
            this.state.customQuote.text = words.join(" ");
        }catch (e) {
            console.log(e);
        }

        this.state.quotes.unshift({
            slogan: this.state.customQuote.text,
            id: "custom_" + this.state.quotes.length + 1,
            custom: true,
            sale: "both",
            type: "both",
            index: 0
        });

        this.setState({quotes: this.state.quotes, customCount: this.state.customCount + 1}, () => {
            console.log(this.state.quotes);
        });

        function capitalizeFLetter(string) {
            return  string.charAt(0).toUpperCase() + string.slice(1);
        }

    }

    _addCustomQuote() {
        try {
            this.state.customQuote.modal = true;
            this.state.customQuote.text = "";
            this.setState({
                customQuote: this.state.customQuote
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _moreQuotes() {
        try {
            this.setState({page_load: window.innerWidth > 1050?5:4}, () => {
                this.setState({
                    page: this.state.page + (this.state.page === 1?2:1)
                }, () => {
                    console.log(this.state.page);
                    this._scrollTo("bottom");
                    quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                });
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _back(){
        if(!this.state.steps[this.state.step].previous){
            /*
            if(this.state.inhouse){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/slideshow");
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/images");
            }
            */
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/images");
        }else{
            window.scrollTo(0, 0);
            this.setState({step: this.state.steps[this.state.step].previous});
        }
    }

    _next(){
        if(Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved){
            if(this.state.customQuote.saved && this.state.customQuote.selected){
                cartRegister.setAdAdminQuotes(this.state.customQuote);
            }

            //SET
            if(this.state.steps.action && this.state.steps.action.selected){
                themeRegister.setItem("last_subtitle", this.state.steps.action.selected.slogan);
            }

            if(salesChannelRegister.get("name") === "yieldlock"){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
            }
        }
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _renderStep(){
        try {
            return this.state.steps[this.state.step].step;
        }catch (e) {}
    }

    _renderStepTitle(){
        try {
            return this.state.steps[this.state.step].title[langRegister.lang()];
        }catch (e) {
            console.log(e);
        }
    }

    _renderAdminQuote(e){
        try{
            const re = /^[\x00-\xFF]*$/;
            if (e.target.value === '' || re.test(e.target.value)) {
                this.state.customQuote.text = e.target.value;
                this.setState({customQuote: this.state.customQuote});
            }
        }catch (e) {
            console.log(e);
        }
    }

    _renderSelected(prop){
        try {
            return this.state.steps[this.state.step].selected.id === prop.id;
        }catch (e) {
            return false;
        }
    }

    _renderQuote(slogan) {
        try {
            let highlight = flowRegister.getValue("slogan_highlight");
            let string = slogan.replace(highlight, '<bold><div>&nbsp;' + highlight + '&nbsp;</div></bold>');
            return (<span {...innerHtml(string)}></span>);
        } catch (error) {
            return slogan;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-quotes", item);
    }

    render() {
        return (
            <div>
                <BoosterHeader history={this.props.history} view={"signup"} props={this.props}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        {
                            !this.state.error &&
                            <div className={Styles.title}>
                                {
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}>
                                        {this._renderStepTitle()}
                                    </div>
                                }
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.quotesContainer}>

                                {
                                    !this.state.customQuote.modal &&
                                    this.state.quotes.filter((item) => {
                                        return (item.sale === this.state.sale || item.sale === "both")
                                    }).filter((item) => {
                                        return (item.type === (salesChannelRegister.get("name")==="yieldlock"?"yieldlock":(salesChannelRegister.get("name")==="boostabostad"?"boostabostad":"property")))
                                    }).filter((item) => {
                                        return (item.detail === this.state.step)
                                    }).map((prop, i) => {
                                        return (
                                            <div key={i}
                                                 onClick={() => this._selectQuote(prop)}
                                                 className={
                                                     cx(Styles.quotesContainerItem,
                                                         {
                                                             [Styles.quotesContainerItemActive]: this._renderSelected(prop),
                                                         })
                                                 }>
                                                {
                                                    !prop.highlight &&
                                                <div className={Styles.quotesContainerItemQuote}>
                                                    {this._renderQuote(prop.slogan)}
                                                </div>
                                                }
                                                {
                                                    prop.highlight &&
                                                    <div className={Styles.quotesContainerItemQuote}>
                                                        <bold>{prop.slogan}</bold>
                                                    </div>
                                                }

                                            </div>
                                        )
                                    })
                                }
                                {
                                    <div
                                        onClick={() => this._back()}
                                        style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}
                                        className={
                                            cx(Styles.backButton,
                                                {
                                                    [Styles.backButtonCenter]: false,
                                                })
                                        }>
                                        {this._renderText("item_4")}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width:"100%"}}/>
            </div>
        );
    }
}

export default BoosterSlogansDivided;


// WEBPACK FOOTER //
// ./src/pages/booster-slogans-divided/component.js